module.exports = __webpack_public_path__ + "static/img/ikonaNotatkaDisabled-ON.9cf30960.png";